/* eslint-disable import/first */
import React from 'react';
import { RiMapPin2Line } from '@react-icons/all-files/ri/RiMapPin2Line';
import { FormattedMessage, useIntl } from 'react-intl';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;

const { selectStoreById } = Slices.storeSlice;

import css from './index.module.scss';

function StoreBox({ id = 0, mode = '' }) {
  const intl = useIntl();
  const store = useSelector((state) => selectStoreById(state, id));

  const name = 'name_' + intl.locale;
  const addressVal = 'address_' + intl.locale;

  const {
    [name]: storeName = '',
    [addressVal]: address = '',
    startTime = '',
    endTime = '',
  } = store;
  var d = new Date(startTime); /* midnight in China on April 13th */
  const startStore = d.toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
  });

  var end = new Date(endTime); /* midnight in China on April 13th */
  const endStore = end.toLocaleTimeString('en-US', {
    timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className={css.root}>
      <div className={css.storePinWrapper}>
        <div className={css.storePin}>
          <RiMapPin2Line />
        </div>
      </div>
      <div className={css.storeDetails}>
        <div className={css.title}>{storeName}</div>
        <div className={css.location}>{address}</div>
        <div className={css.hours}>
          <div className={css.hTitle}>
            <FormattedMessage
              id={`openinghours`}
              values={{
                startTime: startStore,
                endTime: endStore,
              }}
            />
          </div>
          <div className={css.hValue}>
            <FormattedMessage
              id={`openinghours_time`}
              values={{
                startTime: startStore,
                endTime: endStore,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StoreBox;
